import styled from "styled-components";

export const CheckboxContainer = styled.div`
    display: inline-block;
    vertical-align: middle;
`;


export const Input = styled.input`
margin: 0  5px;
`
export const Layout = styled.div`
    padding: 5px;
`;
